import AppDataGrid from '@shared/components/DataGrid';
import { ConsumptionTableConfigType, StockViewKey } from '@shared/entity';

type ConsumptionTableProps = {
  config: ConsumptionTableConfigType;
  view: StockViewKey;
};

const ConsumptionTable = ({ config, view }: ConsumptionTableProps) => (
  <AppDataGrid rows={config[view].rows} columns={config[view].columns} />
);

export default ConsumptionTable;
